(function(){
  /* ---- pk shared canvas helpers (C_*) ---- */
  function C_hx(c) { c = (c || '#000').replace('#', ''); if (c.length === 3) c = c[0] + c[0] + c[1] + c[1] + c[2] + c[2]; return [parseInt(c.substr(0, 2), 16) || 0, parseInt(c.substr(2, 2), 16) || 0, parseInt(c.substr(4, 2), 16) || 0]; }
  function C_mix(c, t, f) { var a = C_hx(c), b = C_hx(t); return 'rgb(' + Math.round(a[0] + (b[0] - a[0]) * f) + ',' + Math.round(a[1] + (b[1] - a[1]) * f) + ',' + Math.round(a[2] + (b[2] - a[2]) * f) + ')'; }
  function C_rgba(c, a) { var x = C_hx(c); return 'rgba(' + x[0] + ',' + x[1] + ',' + x[2] + ',' + a + ')'; }
  function C_lum(c) { var a = C_hx(c); return (0.299 * a[0] + 0.587 * a[1] + 0.114 * a[2]) / 255; }
  function C_rng(seed) { var s = (seed >>> 0) || 1; return function () { s ^= s << 13; s >>>= 0; s ^= s >> 17; s ^= s << 5; s >>>= 0; return s / 4294967296; }; }
  function C_hash(t) { var h = 2166136261; t = String(t || ''); for (var i = 0; i < t.length; i++) { h ^= t.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; }
  function C_fs(ctx) { var m = ctx.font.match(/(\d+(?:\.\d+)?)px/); return m ? parseFloat(m[1]) : 40; }
  function C_spW(ctx, t, sp) { var w = 0; for (var i = 0; i < t.length; i++) w += ctx.measureText(t[i]).width + (i < t.length - 1 ? sp : 0); return w; }
  function C_sp(ctx, t, x, y, sp, align) { var w = C_spW(ctx, t, sp), xx = align === 'left' ? x : align === 'right' ? x - w : x - w / 2, keep = ctx.textAlign; ctx.textAlign = 'left'; for (var i = 0; i < t.length; i++) { ctx.fillText(t[i], xx, y); xx += ctx.measureText(t[i]).width + sp; } ctx.textAlign = keep; return w; }
  /* fit(ctx, text, fontFn(size), size, maxW, spacingFactor) -> size */
  function C_fit(ctx, t, fn, size, maxW, sp) { var s = size; ctx.font = fn(s); while (s > 16 && C_spW(ctx, t, s * (sp || 0)) > maxW) { s -= 4; ctx.font = fn(s); } return s; }
  function C_grain(ctx, x, y, w, h, n, col, seed) { var r = C_rng(seed); ctx.fillStyle = col; for (var i = 0; i < n; i++) { var z = 2 + r() * 5; ctx.fillRect(x + r() * w, y + r() * h, z, z); } }
  function C_named(v, map, def) { v = String(v || '').trim(); if (/^#[0-9a-f]{3}([0-9a-f]{3})?$/i.test(v)) return v; var k = v.toLowerCase(); return map[k] || def; }
  function C_cover(ctx, photo, bx, by, bw, bh) {
    var iw = photo.img.naturalWidth || photo.img.width, ih = photo.img.naturalHeight || photo.img.height;
    var sc = Math.max(bw / iw, bh / ih) * (photo.scale || 1), dw = iw * sc, dh = ih * sc, mx = (dw - bw) / 2, my = (dh - bh) / 2;
    photo.ox = Math.max(-mx, Math.min(mx, photo.ox || 0)); photo.oy = Math.max(-my, Math.min(my, photo.oy || 0));
    ctx.drawImage(photo.img, bx - mx + photo.ox, by - my + photo.oy, dw, dh);
  }

/* Cheeky Business DTF design: "The [Surname] Family Christmas" one-ink lockup (after the Etsy best-sellers).
   Transparent print file, 11 x 11 in @300dpi (prints 26-28cm wide on an adult chest; scale down for kids).
   Fields: family (surname), who (optional wearer line e.g. MUM / ELLA), year, ink (white|red|green|gold|black) */
var W = 3300, H = 3300;
var FONT_CSS = 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@800;900&family=Jost:wght@500;600&family=Great+Vibes&display=swap';
var FONT_LOADS = ['900 200px "Playfair Display"', '600 100px Jost', '500 100px Jost', '200px "Great Vibes"'];
var FM_INKS = {white: '#ffffff', red: '#b4152b', green: '#1f5a3c', gold: '#d6a136', black: '#151515'};

function fmNorm(i) {
  i = i || {}; var t = !!i.__typed;
  function v(k, d) { var x = i[k]; if (x === undefined || x === null) return d; x = String(x).trim(); return (x === '' && !t) ? d : x; }
  var ink = String(i.ink || 'white').toLowerCase();
  return {family: v('family', 'Johnson'), who: v('who', ''), year: v('year', '2026'), ink: FM_INKS[ink] || C_named(ink, FM_INKS, '#ffffff')};
}

function fmTree(ctx, x, y, h, col) {           // tiny pine: three stacked tiers + trunk
  ctx.fillStyle = col; var w = h * 0.62;
  for (var k = 0; k < 3; k++) {
    var ty = y + k * h * 0.24, tw = w * (0.55 + k * 0.22);
    ctx.beginPath(); ctx.moveTo(x, ty); ctx.lineTo(x + tw / 2, ty + h * 0.36); ctx.lineTo(x - tw / 2, ty + h * 0.36); ctx.closePath(); ctx.fill();
  }
  ctx.fillRect(x - h * 0.05, y + h * 0.84, h * 0.1, h * 0.16);
}

function fmSpark(ctx, x, y, r, col) {          // four-point sparkle
  ctx.fillStyle = col; ctx.beginPath();
  ctx.moveTo(x, y - r); ctx.quadraticCurveTo(x + r * 0.12, y - r * 0.12, x + r, y); ctx.quadraticCurveTo(x + r * 0.12, y + r * 0.12, x, y + r);
  ctx.quadraticCurveTo(x - r * 0.12, y + r * 0.12, x - r, y); ctx.quadraticCurveTo(x - r * 0.12, y - r * 0.12, x, y - r); ctx.fill();
}

function fmFlake(ctx, x, y, r, col, lw) {      // six-arm snowflake
  ctx.strokeStyle = col; ctx.lineWidth = lw; ctx.lineCap = 'round';
  for (var k = 0; k < 6; k++) {
    var a = k * Math.PI / 3, ex = x + r * Math.cos(a), ey = y + r * Math.sin(a);
    ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(ex, ey); ctx.stroke();
    var bx = x + r * 0.6 * Math.cos(a), by = y + r * 0.6 * Math.sin(a);
    ctx.beginPath(); ctx.moveTo(bx + r * 0.22 * Math.cos(a + 0.9), by + r * 0.22 * Math.sin(a + 0.9)); ctx.lineTo(bx, by);
    ctx.lineTo(bx + r * 0.22 * Math.cos(a - 0.9), by + r * 0.22 * Math.sin(a - 0.9)); ctx.stroke();
  }
}

function drawAll(ctx, scale, inp) {
  ctx.setTransform(scale, 0, 0, scale, 0, 0);
  ctx.clearRect(0, 0, W, H);
  var d = fmNorm(inp), ink = d.ink, cx = W / 2;
  ctx.fillStyle = ink; ctx.textAlign = 'center'; ctx.textBaseline = 'alphabetic';

  // THE, flanked by little trees
  ctx.font = '600 230px Jost';
  var tw = C_sp(ctx, 'THE', cx, 560, 40, 'center');
  fmTree(ctx, cx - tw / 2 - 210, 330, 250, ink); fmTree(ctx, cx + tw / 2 + 210, 330, 250, ink);

  // SURNAME: condensed high-contrast serif caps (Playfair squeezed to 72%)
  var name = (d.family || '').toUpperCase(), sx = 0.72, top = 640;
  var size = 980, maxW = 2900 / sx;
  ctx.font = '900 ' + size + 'px "Playfair Display"';
  while (size > 300 && C_spW(ctx, name, size * 0.01) > maxW) { size -= 20; ctx.font = '900 ' + size + 'px "Playfair Display"'; }
  var capH = size * 0.71, base = top + capH;
  ctx.save(); ctx.translate(cx, base); ctx.scale(sx, 1); ctx.fillStyle = ink;
  C_sp(ctx, name, 0, 0, size * 0.01, 'center'); ctx.restore();

  // FAMILY
  var fy = base + 300;
  ctx.font = '600 210px Jost'; C_sp(ctx, 'FAMILY', cx, fy, 62, 'center');

  // Christmas script + sparkles + flakes
  var sy = fy + 720, ss = 760;
  ctx.font = ss + 'px "Great Vibes"';
  while (ss > 400 && ctx.measureText('Christmas').width > 2500) { ss -= 20; ctx.font = ss + 'px "Great Vibes"'; }
  var cw = ctx.measureText('Christmas').width;
  ctx.lineWidth = ss * 0.02; ctx.strokeStyle = ink; ctx.lineJoin = 'round';
  ctx.fillText('Christmas', cx + 20, sy); ctx.strokeText('Christmas', cx + 20, sy);   // stroke = a touch heavier so it survives DTF
  var L = cx - cw / 2, R = cx + cw / 2 + 40;
  fmSpark(ctx, L - 150, sy - 420, 110, ink); fmSpark(ctx, L - 40, sy - 190, 55, ink);
  fmFlake(ctx, R + 150, sy - 330, 80, ink, 15); fmSpark(ctx, R + 120, sy - 40, 70, ink);
  fmSpark(ctx, R - 40, sy - 560, 50, ink);

  // year line with dots, and the wearer
  var yy = sy + 360;
  if (d.year) {
    ctx.font = '500 170px Jost'; var yw = C_sp(ctx, d.year, cx, yy, 60, 'center');
    ctx.beginPath(); ctx.arc(cx - yw / 2 - 120, yy - 58, 18, 0, 6.3); ctx.arc(cx + yw / 2 + 120, yy - 58, 18, 0, 6.3); ctx.fill();
  }
  if (d.who) {
    var wy = d.year ? yy + 300 : yy;
    var ws = C_fit(ctx, d.who.toUpperCase(), function (s) { return '500 ' + s + 'px Jost'; }, 190, 2600, 0.3);
    ctx.font = '500 ' + ws + 'px Jost'; C_sp(ctx, d.who.toUpperCase(), cx, wy, ws * 0.3, 'center');
  }
}

/* Cheeky Business live personaliser (cb-live). ES5 only (injected for old Safari).
   window.CB_LIVE = {design:'fam'|'emb', product:{variants:[...]}, sweat:{Colour:url}, tee:url, kidtee:url, ...}
   DTF designs: preview on the real garment at the exact print position; on Add to basket the full-size transparent
   PNG is uploaded and saved on the order as _print_file, with _spec (the inputs) so the file can always be rebuilt.
   Embroidery: preview with the same letterforms as the stitch font; the DST is built from _spec after the order. */
(function () {
  var CFG = window.CB_LIVE; if (!CFG) return;
  var CLOUD = {cloudName: 'dkvg84nse', preset: 'pk_personalise'};
  var root = document.querySelector('[data-cbl]'); if (!root) return;
  function q(s) { return root.querySelector(s); }
  function qa(s) { return root.querySelectorAll(s); }

  /* ---------- garments: photo + exact placement boxes (1000x1000 photo space) ---------- */
  var BOX = {
    sweat: {chest: [384, 348, 232, 232], left: [546, 336, 76, 44], sleeve: [806, 676, 62, 44, -108]},
    tee:   CFG.teeBox || {chest: [340, 262, 320, 320], left: [560, 250, 104, 60]},
    kidtee: CFG.kidBox || {chest: [380, 262, 240, 240], left: [560, 250, 80, 46]}
  };
  var COLOURS = CFG.colours;   // [{n,h,img,light}]
  var imgCache = {};
  function loadImg(u) {
    if (imgCache[u]) return imgCache[u];
    imgCache[u] = new Promise(function (res) { var im = new Image(); im.crossOrigin = 'anonymous'; im.onload = function () { res(im); }; im.onerror = function () { res(null); }; im.src = u; });
    return imgCache[u];
  }
  function lum(h) { h = h.replace('#', ''); var r = parseInt(h.substr(0, 2), 16), g = parseInt(h.substr(2, 2), 16), b = parseInt(h.substr(4, 2), 16); return (0.299 * r + 0.587 * g + 0.114 * b) / 255; }

  /* ---------- state ---------- */
  var S = {style: CFG.styles[0].v, colour: CFG.defaultColour || COLOURS[0].n, size: '', view: 'front', fields: {}};
  function styleObj() { for (var i = 0; i < CFG.styles.length; i++) if (CFG.styles[i].v === S.style) return CFG.styles[i]; return CFG.styles[0]; }
  function colourObj() { for (var i = 0; i < COLOURS.length; i++) if (COLOURS[i].n === S.colour) return COLOURS[i]; return COLOURS[0]; }
  function garmentKind() { var g = styleObj().g; return g; }   // 'sweat' | 'tee' | 'kidtee' | 'kidsweat'

  /* ---------- inputs ---------- */
  function readFields() {
    var o = {}, els = qa('[data-cbl-f]');
    for (var i = 0; i < els.length; i++) {
      var e = els[i];
      if (e.type === 'radio') { if (e.checked) o[e.getAttribute('data-cbl-f')] = e.value; }
      else o[e.getAttribute('data-cbl-f')] = e.value;
    }
    o.__typed = true; S.fields = o; return o;
  }

  /* ---------- the design layer ---------- */
  function autoInk(f) {
    if (f.ink && f.ink !== 'auto') return f.ink;
    var c = colourObj(); return lum(c.h) > 0.62 ? (CFG.lightInk || 'red') : 'white';
  }
  var dCanvas = document.createElement('canvas');
  function designCanvas(scale) {          // DTF art at preview scale
    var f = readFields(), inp = {}; for (var k in f) inp[k] = f[k]; inp.ink = autoInk(f);
    dCanvas.width = Math.round(W * scale); dCanvas.height = Math.round(H * scale);
    drawAll(dCanvas.getContext('2d'), scale, inp); return dCanvas;
  }

  /* embroidery preview: same letterforms as the stitch fonts, thread colour, raised look */
  var EMBF = {pacifico: {css: 'Pacifico', w: 400, k: 1.0}, signature: {css: 'Sacramento', w: 400, k: 1.0}, bold: {css: 'Kaushan Script', w: 400, k: 0.9}, serif: {css: 'Marcellus SC', w: 400, k: 0.8}};
  function heartPath(ctx, x, y, s) {
    ctx.beginPath(); ctx.moveTo(x, y + s * 0.85);
    ctx.bezierCurveTo(x, y + s * 0.77, x - s * 0.5, y + s * 0.55, x - s * 0.5, y + s * 0.3);
    ctx.bezierCurveTo(x - s * 0.5, y + s * 0.08, x - s * 0.12, y - s * 0.02, x, y + s * 0.22);
    ctx.bezierCurveTo(x + s * 0.12, y - s * 0.02, x + s * 0.5, y + s * 0.08, x + s * 0.5, y + s * 0.3);
    ctx.bezierCurveTo(x + s * 0.5, y + s * 0.55, x, y + s * 0.77, x, y + s * 0.85); ctx.closePath();
  }
  function stitchText(ctx, txt, x, y, px, font, thread, align) {
    var F = EMBF[font] || EMBF.signature, fnt = F.w + ' ' + px + 'px "' + F.css + '"';
    ctx.save(); ctx.font = fnt; var w = ctx.measureText(txt).width; ctx.restore();
    var pad = Math.ceil(px * 0.6), ss = 3, oc = document.createElement('canvas');           // 3x supersampled thread layer
    oc.width = Math.ceil((w + pad * 2) * ss); oc.height = Math.ceil(px * 2 * ss); var o = oc.getContext('2d');
    o.scale(ss, ss); o.font = fnt; o.textBaseline = 'alphabetic'; o.fillStyle = thread;
    var bx = pad, by = px * 1.25; o.fillText(txt, bx, by);
    if (font === 'signature') { o.lineWidth = px * 0.018; o.strokeStyle = thread; o.strokeText(txt, bx, by); }
    o.globalCompositeOperation = 'source-atop';                                              // thread sheen: fine diagonal satin lines
    var light = lum(thread) < 0.5;
    o.lineWidth = Math.max(0.35, px * 0.01);
    for (var i = -px; i < w + pad * 2 + px; i += Math.max(1.2, px * 0.045)) {
      o.strokeStyle = light ? 'rgba(255,255,255,0.22)' : 'rgba(0,0,0,0.16)';
      o.beginPath(); o.moveTo(i, 0); o.lineTo(i + px * 0.55, px * 2); o.stroke();
    }
    var dx = (align === 'center') ? x - w / 2 - pad : x - pad, dy = y - by;
    ctx.save(); ctx.shadowColor = 'rgba(0,0,0,0.38)'; ctx.shadowBlur = Math.max(1, px * 0.05); ctx.shadowOffsetY = Math.max(0.5, px * 0.03);
    ctx.drawImage(oc, dx, dy, oc.width / ss, oc.height / ss); ctx.restore();
    return w;
  }
  function embHeart(ctx, x, y, s, thread) {
    ctx.save(); heartPath(ctx, x, y, s); ctx.lineWidth = Math.max(0.5, s * 0.07); ctx.strokeStyle = thread; ctx.lineJoin = 'round';
    ctx.shadowColor = 'rgba(0,0,0,0.3)'; ctx.shadowBlur = s * 0.05; ctx.shadowOffsetY = s * 0.03; ctx.stroke(); ctx.restore();
  }
  function threadHex() { var f = S.fields; return f.thread_hex || (lum(colourObj().h) > 0.62 ? '#2b2b2b' : '#ffffff'); }
  function drawChestEmb(ctx, bx, by, bw, bh) {
    var f = S.fields, t = (f.chest || '').trim(); if (!t) return;
    var px = bh * 0.95; ctx.font = '400 ' + px + 'px "' + (EMBF[f.font] || EMBF.signature).css + '"';
    var maxW = bw * (f.heart === 'no' ? 1 : 0.8);
    while (px > 6 && ctx.measureText(t).width > maxW) { px -= 1; ctx.font = '400 ' + px + 'px "' + (EMBF[f.font] || EMBF.signature).css + '"'; }
    var w = ctx.measureText(t).width, tot = w + (f.heart === 'no' ? 0 : px * 0.45), x = bx + (bw - tot) / 2, base = by + bh * 0.78;
    stitchText(ctx, t, x, base, px, f.font, threadHex(), 'left');
    if (f.heart !== 'no') embHeart(ctx, x + w + px * 0.25, base - px * 0.55, px * 0.32, threadHex());
  }
  function sleeveNames() { return String(S.fields.sleeve || '').split(/[\n,|]+/).map(function (s) { return s.trim(); }).filter(function (s) { return s; }).slice(0, 5); }
  function drawSleeveEmb(ctx, cx, cy, bw, bh, ang) {     // same as the DST: Pacifico ~9mm, 11.9mm line pitch, heart on each baseline
    var n = sleeveNames(); if (!n.length) return;
    var k = 8.3, pitch = 1.19 * k, px = 1.0 * k, x0 = -bw / 2 + 0.2 * k, hs = 0.44 * k;
    ctx.save(); ctx.translate(cx, cy); ctx.rotate(ang * Math.PI / 180);
    for (var i = 0; i < n.length; i++) {
      var y = -((n.length - 1) * pitch) / 2 + i * pitch + px * 0.3;
      if (S.fields.heart !== 'no') embHeart(ctx, x0 + hs / 2, y - 0.6 * k, hs, threadHex());
      stitchText(ctx, n[i], x0 + (S.fields.heart !== 'no' ? 0.62 * k : 0), y, px, 'pacifico', threadHex(), 'left');
    }
    ctx.restore();
  }

  /* ---------- the stage ---------- */
  var stage = q('[data-cbl-canvas]'), sctx = stage.getContext('2d'), drawTok = 0;
  function garmentUrl() {
    var c = colourObj(), g = garmentKind();
    if (g === 'sweat' || g === 'kidsweat') return c.img;
    return g === 'kidtee' ? CFG.kidtee : CFG.tee;
  }
  function tinted(img, hex) {     // white tee photo -> any Gildan colour (multiply, keep the photo's alpha)
    var c = document.createElement('canvas'); c.width = img.width; c.height = img.height; var x = c.getContext('2d');
    x.drawImage(img, 0, 0); x.globalCompositeOperation = 'multiply'; x.fillStyle = hex; x.fillRect(0, 0, c.width, c.height);
    if (lum(hex) < 0.25) { x.globalCompositeOperation = 'screen'; x.globalAlpha = 0.10; x.drawImage(img, 0, 0); x.globalAlpha = 1; }
    x.globalCompositeOperation = 'destination-in'; x.drawImage(img, 0, 0); return c;
  }
  function render() {
    var tok = ++drawTok, g = garmentKind(), u = garmentUrl(), isTint = !(g === 'sweat' || g === 'kidsweat');
    readFields();
    loadImg(u).then(function (img) {
      if (tok !== drawTok) return;
      var Wc = stage.width = 1000, Hc = stage.height = 1000;
      sctx.fillStyle = '#f3f3f1'; sctx.fillRect(0, 0, Wc, Hc);
      var zoom = S.view !== 'front' ? zoomRect() : null;
      sctx.save();
      if (zoom) { var zs = Wc / zoom[2]; sctx.scale(zs, zs); sctx.translate(-zoom[0], -zoom[1]); }
      if (img) sctx.drawImage(isTint ? tinted(img, colourObj().h) : img, 0, 0, 1000, 1000);
      var B = BOX[g === 'kidsweat' ? 'sweat' : g] || BOX.sweat;
      if (CFG.design === 'fam') {
        var k = g === 'kidsweat' ? 0.78 : 1, bx = B.chest, w = bx[2] * k, h = bx[3] * k;
        var dc = designCanvas(zoom ? 0.3 : 0.16);
        // fabric shading inside the ink only: multiply the garment's own folds onto the print, then mask to the print
        var tc = document.createElement('canvas'); tc.width = dc.width; tc.height = dc.height; var tx = tc.getContext('2d');
        tx.drawImage(dc, 0, 0);
        if (img) { var sh = document.createElement('canvas'); sh.width = tc.width; sh.height = tc.height; var sx = sh.getContext('2d');
          var gs = img.width / 1000;
          sx.drawImage(img, (bx[0] + (bx[2] - w) / 2) * gs, bx[1] * gs, w * gs, h * gs, 0, 0, tc.width, tc.height);
          try {   // relative shading: each pixel's brightness / the area's average -> folds only, never a tint
            var id = sx.getImageData(0, 0, sh.width, sh.height), px = id.data, n = px.length / 4, sum = 0, i;
            for (i = 0; i < px.length; i += 4) sum += px[i] * 0.3 + px[i + 1] * 0.59 + px[i + 2] * 0.11;
            var mean = sum / n || 1;
            for (i = 0; i < px.length; i += 4) { var l = (px[i] * 0.3 + px[i + 1] * 0.59 + px[i + 2] * 0.11) / mean, v = Math.max(150, Math.min(255, Math.round(255 * (0.08 + 0.92 * l)))); px[i] = px[i + 1] = px[i + 2] = v; px[i + 3] = 255; }
            sx.putImageData(id, 0, 0);
            tx.globalCompositeOperation = 'multiply'; tx.drawImage(sh, 0, 0);
          } catch (_e) {}
          tx.globalCompositeOperation = 'destination-in'; tx.drawImage(dc, 0, 0); }
        sctx.save(); sctx.globalAlpha = 0.97; sctx.drawImage(tc, bx[0] + (bx[2] - w) / 2, bx[1], w, h); sctx.restore();
      } else {
        var L = B.left; drawChestEmb(sctx, L[0], L[1], L[2], L[3]);
        if (B.sleeve) { var Sl = B.sleeve; drawSleeveEmb(sctx, Sl[0], Sl[1], Sl[2], Sl[3], Sl[4]); }
      }
      sctx.restore();
      var lab = q('[data-cbl-viewlab]'); if (lab) lab.textContent = S.view === 'front' ? 'Front' : S.view === 'chest' ? 'Close-up: chest' : 'Close-up: sleeve';
    });
  }
  function zoomRect() {
    var g = garmentKind(), B = BOX[g === 'kidsweat' ? 'sweat' : g] || BOX.sweat;
    if (CFG.design === 'fam') return [B.chest[0] - 60, B.chest[1] - 70, B.chest[2] + 120, B.chest[2] + 120];
    if (S.view === 'sleeve' && B.sleeve) return [B.sleeve[0] - 95, B.sleeve[1] - 95, 190, 190];
    return [B.left[0] - 70, B.left[1] - 75, 216, 216];
  }

  /* ---------- pickers ---------- */
  function variantFor() {
    var st = S.style, sz = S.size, vs = CFG.product.variants;
    for (var i = 0; i < vs.length; i++) if (vs[i].option1 === st && vs[i].option2 === sz) return vs[i];
    for (i = 0; i < vs.length; i++) if (vs[i].option1 === st) return vs[i];
    return vs[0];
  }
  function sizesFor() { var st = styleObj(), out = [], vs = CFG.product.variants; for (var i = 0; i < vs.length; i++) if (vs[i].option1 === st.v && out.indexOf(vs[i].option2) < 0) out.push(vs[i].option2); return out; }
  function money(c) { return '£' + (c / 100).toFixed(2); }
  function buildSizes() {
    var box = q('[data-cbl-sizes]'), sz = sizesFor(); if (sz.indexOf(S.size) < 0) S.size = sz[Math.min(1, sz.length - 1)] || '';
    var h = ''; for (var i = 0; i < sz.length; i++) h += '<button type="button" class="cbl-pill' + (sz[i] === S.size ? ' on' : '') + '" data-size="' + sz[i] + '">' + sz[i] + '</button>';
    box.innerHTML = h;
  }
  function buildStyles() {
    var box = q('[data-cbl-styles]'), h = '';
    for (var i = 0; i < CFG.styles.length; i++) {
      var s = CFG.styles[i], v = null, vs = CFG.product.variants;
      for (var j = 0; j < vs.length; j++) if (vs[j].option1 === s.v) { v = vs[j]; break; }
      h += '<button type="button" class="cbl-style' + (s.v === S.style ? ' on' : '') + '" data-style="' + s.v + '"><b>' + s.label + '</b><span>' + (v ? money(v.price) : '') + '</span></button>';
    }
    box.innerHTML = h;
  }
  function buildColours() {
    var box = q('[data-cbl-colours]'), h = '';
    for (var i = 0; i < COLOURS.length; i++) {
      var c = COLOURS[i]; h += '<button type="button" class="cbl-sw' + (c.n === S.colour ? ' on' : '') + '" data-colour="' + c.n + '" title="' + c.n + '" style="background:' + c.h + '"></button>';
    }
    box.innerHTML = h; var n = q('[data-cbl-colname]'); if (n) n.textContent = S.colour;
  }
  function syncVariant() {
    var v = variantFor(), ids = document.querySelectorAll('form[action*="/cart/add"] [name="id"]');
    for (var i = 0; i < ids.length; i++) { ids[i].value = v.id; ids[i].dispatchEvent(new Event('change', {bubbles: true})); }
    var p = q('[data-cbl-price]'); if (p) p.textContent = money(v.price);
    var prs = document.querySelectorAll('.price-item--regular, .price-item--sale, .price__regular .price-item'); for (i = 0; i < prs.length; i++) prs[i].textContent = money(v.price) + ' GBP';
  }
  function refreshAll() { buildStyles(); buildSizes(); buildColours(); syncVariant(); render(); }

  root.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('button') : null; if (!t || !root.contains(t)) return;
    if (t.getAttribute('data-style')) { S.style = t.getAttribute('data-style'); var cs = styleObj().colours; if (cs && cs.indexOf(S.colour) < 0) S.colour = cs[0]; refreshAll(); }
    else if (t.getAttribute('data-size')) { S.size = t.getAttribute('data-size'); buildSizes(); syncVariant(); }
    else if (t.getAttribute('data-colour')) { S.colour = t.getAttribute('data-colour'); buildColours(); var ink = q('[data-cbl-f="ink"]'); render(); }
    else if (t.getAttribute('data-view')) { S.view = t.getAttribute('data-view'); var vb = qa('[data-view]'); for (var i = 0; i < vb.length; i++) vb[i].classList.toggle('on', vb[i] === t); render(); }
    else if (t.getAttribute('data-thread')) { var th = q('[data-cbl-f="thread_hex"]'); th.value = t.getAttribute('data-thread'); var tb = qa('[data-thread]'); for (var j = 0; j < tb.length; j++) tb[j].classList.toggle('on', tb[j] === t); var tn = q('[data-cbl-threadname]'); if (tn) tn.textContent = t.title; render(); }
  });
  var deb; root.addEventListener('input', function () { clearTimeout(deb); deb = setTimeout(render, 60); });
  root.addEventListener('change', function () { render(); });

  /* ---------- add to basket: print file + spec on the order ---------- */
  function ov(m) { var o = document.getElementById('cbl-ov'); if (!o) { o = document.createElement('div'); o.id = 'cbl-ov'; document.body.appendChild(o); } o.innerHTML = '<div><b>' + m + '</b><span>Saving your print-ready file</span></div>'; o.style.display = 'flex'; }
  function hide() { var o = document.getElementById('cbl-ov'); if (o) o.style.display = 'none'; }
  function upload(blob, name) {
    var fd = new FormData(); fd.append('file', blob, name); fd.append('upload_preset', CLOUD.preset);
    return fetch('https://api.cloudinary.com/v1_1/' + CLOUD.cloudName + '/image/upload', {method: 'POST', body: fd})
      .then(function (r) { return r.json(); }).then(function (j) { if (!j.secure_url) throw new Error('upload'); return j.secure_url; });
  }
  function toBlob(c, type, qy) { return new Promise(function (res) { c.toBlob(function (b) { res(b); }, type, qy); }); }
  function printFile() {      // the full-size transparent DTF file
    var c = document.createElement('canvas'), f = readFields(), inp = {}; for (var k in f) inp[k] = f[k]; inp.ink = autoInk(f);
    c.width = W; c.height = H; drawAll(c.getContext('2d'), 1, inp); return toBlob(c, 'image/png');
  }
  function addJSON(props) {
    var v = variantFor();
    return fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({items: [{id: Number(v.id), quantity: Number((document.querySelector('[name="quantity"]') || {}).value || 1), properties: props}]})})
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || ('HTTP ' + r.status)); }); return r.json(); });
  }
  function openCart() { document.dispatchEvent(new CustomEvent('cart:refresh')); setTimeout(function () { window.location.href = '/cart'; }, 200); }
  var busy = false;
  function atc(e) {
    e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    if (busy) return;
    var f = readFields(), miss = CFG.required.filter(function (k) { return !(f[k] || '').trim(); });
    if (miss.length) { var el = q('[data-cbl-f="' + miss[0] + '"]'); if (el) { el.focus(); el.classList.add('err'); } return; }
    if (!S.size) { q('[data-cbl-sizes]').classList.add('err'); return; }
    busy = true; ov('Making your design…');
    var spec = {design: CFG.design, style: S.style, size: S.size, colour: S.colour, colour_hex: colourObj().h, fields: {}};
    for (var k in f) if (k !== '__typed') spec.fields[k] = f[k];
    if (CFG.design === 'fam') spec.fields.ink = autoInk(f);
    var props = CFG.visibleProps(f, S, autoInk(f));
    props._spec = JSON.stringify(spec); props._design = CFG.design;
    var prevC = document.createElement('canvas'); prevC.width = 900; prevC.height = 900; prevC.getContext('2d').drawImage(stage, 0, 0, 900, 900);
    var chain = toBlob(prevC, 'image/jpeg', 0.9).then(function (b) { return upload(b, 'preview.jpg'); }).then(function (u) { props._preview = u; }).catch(function () {});
    if (CFG.design === 'fam') chain = chain.then(printFile).then(function (b) { return upload(b, 'print.png'); })
      .then(function (u) { props._print_file = u; }).catch(function () { props._print_file_missing = 'rebuild from _spec'; });
    chain.then(function () { ov('Adding to basket…'); return addJSON(props); })
      .then(function () { hide(); openCart(); })
      .catch(function (err) { busy = false; hide(); alert('Sorry, that did not add to your basket: ' + (err && err.message || err) + '. Please try again.'); });
  }
  function bind() {
    var bs = document.querySelectorAll('form[action*="/cart/add"] [name="add"], product-form button[name="add"], form[action*="/cart/add"] [type="submit"]');
    for (var i = 0; i < bs.length; i++) { if (bs[i].dataset.cblBound) continue; bs[i].dataset.cblBound = '1'; bs[i].addEventListener('click', atc, true); }
    var dyn = document.querySelectorAll('.shopify-payment-button'); for (i = 0; i < dyn.length; i++) dyn[i].style.display = 'none';
  }
  bind(); try { new MutationObserver(bind).observe(document.body, {childList: true, subtree: true}); } catch (_e) {}

  /* ---------- go ---------- */
  var fl = document.createElement('link'); fl.rel = 'stylesheet'; fl.href = FONT_CSS + (CFG.extraFonts ? '' : ''); document.head.appendChild(fl);
  if (CFG.embFontCss) { var f2 = document.createElement('link'); f2.rel = 'stylesheet'; f2.href = CFG.embFontCss; document.head.appendChild(f2); }
  refreshAll();
  var loads = FONT_LOADS.concat(CFG.embFontLoads || []);
  Promise.all(loads.map(function (s) { return document.fonts.load(s).catch(function () {}); })).then(render);
  setTimeout(render, 1500);
})();

})();
